<template>
  <div v-loading="loading" class="enquiry-list">
    <!-- tab切换 -->
    <div class="tab-content">
      <div
        v-for="(item, index) of tabsList"
        :key="index"
        class="tab-btn"
        :class="{ active: currentIndex === index }"
        @click="handleTab(item.value, index)"
      >
        <span style="padding-right: 8px">{{ item.label }}</span>
      </div>
    </div>
    <div v-show="currentIndex == 0" class="search-content">
      <div class="tips">
        <span class="color">提示：</span
        >您录入的数据将在阀门专区进行综合展示。（文本框内最多支持7位整数加5位小数）
      </div>
      <div style="display: flex">
        <el-form
          ref="dynamicValidateForm"
          :model="dynamicValidateForm"
          class="search-form"
          size="small"
          :inline="true"
        >
          <div
            v-for="(domain, index) in dynamicValidateForm.domains"
            :key="index"
          >
            <el-form-item
              label="年份："
              :prop="'domains.' + index + '.statYear'"
            >
              <el-input
                v-model.trim="domain.statYear"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              label="收入总额："
              :prop="'domains.' + index + '.income'"
              :rules="moneyRules('income', domain.income, domain.profit)"
            >
              <el-input
                v-model.trim="domain.income"
                placeholder=""
                oninput="value = value.replace(/[^0-9.]/g, '')"
                @input="onChange('domains.' + index + '.profit')"
              ></el-input>
              <span>万元</span>
            </el-form-item>
            <el-form-item
              label="利润总额："
              :prop="'domains.' + index + '.profit'"
              :rules="moneyRules('profit', domain.income, domain.profit)"
            >
              <el-input
                v-model.trim="domain.profit"
                placeholder=""
                oninput="value = value.replace(/[^0-9.]/g, '');"
                @input="onChange('domains.' + index + '.income')"
              ></el-input>
              <span>万元</span>
            </el-form-item>
          </div>
        </el-form>
        <div class="search-btn">
          <el-button
            size="small"
            type="primary"
            plain
            :disabled="disabledBtn"
            @click="addDomain"
            >新增</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="submitForm('dynamicValidateForm')"
            >提交</el-button
          >
        </div>
      </div>
    </div>
    <common
      v-show="currentIndex == 1"
      :last-ten-years="lastTenYears"
      :table-data="tableData1"
      :oprate-type="oprateType"
      :is-table-loading="isTableLoading"
      @getData="getData"
      @submitTableData="submitTableData"
    ></common>
    <common
      v-show="currentIndex == 2"
      :last-ten-years="lastTenYears"
      :table-data="tableData2"
      :oprate-type="oprateType"
      :is-table-loading="isTableLoading"
      @getData="getData"
      @submitTableData="submitTableData"
    ></common>
    <common
      v-show="currentIndex == 3"
      :last-ten-years="lastTenYears"
      :table-data="tableData3"
      :oprate-type="oprateType"
      :is-table-loading="isTableLoading"
      @getData="getData"
      @submitTableData="submitTableData"
    ></common>
    <common
      v-show="currentIndex == 4"
      :last-ten-years="lastTenYears"
      :table-data="tableData4"
      :oprate-type="oprateType"
      :is-table-loading="isTableLoading"
      @getData="getData"
      @submitTableData="submitTableData"
    ></common>
    <common
      v-show="currentIndex == 5"
      :last-ten-years="lastTenYears"
      :table-data="tableData5"
      :oprate-type="oprateType"
      :is-table-loading="isTableLoading"
      @getData="getData"
      @submitTableData="submitTableData"
    ></common>
  </div>
</template>
<script>
import Common from './Common';
import Api from '../../api/valveDataImport/index';

const currentYear = new Date().getFullYear();
export default {
  components: { Common },
  data() {
    return {
      currentIndex: 0,
      oprateType: '001',
      lastTenYears: [],
      tabsList: [
        { label: '收入及利润', value: '001' },
        { label: '价格走势', value: '002' },
        { label: '产能', value: '003' },
        { label: '国内销量', value: '004' },
        { label: '出口量', value: '005' },
        { label: '存货规模', value: '006' },
      ],
      dynamicValidateForm: {
        domains: [
          {
            statYear: currentYear,
            income: '', // 主营收入
            profit: '',
          },
        ],
      },
      disabledBtn: false,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      isTableLoading: false,
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    this.getLastYear();
    this.initAllData();
  },
  methods: {
    onChange(prop) {
      this.$nextTick(() => {
        this.$refs.dynamicValidateForm.validateField(prop);
      });
    },
    validateMoney(rule, value, callback, type, income, profit) {
      if (value === '') {
        callback(new Error('金额不能为空'));
      } else if (value.indexOf('.') != -1 && value.split('.').length > 2) {
        callback(new Error('请输入正确格式的金额')); // 防止输入多个小数点
      } else if (
        (value.indexOf('.') != -1 && value.split('.')[0].length > 7) ||
        (value.indexOf('.') == -1 && value.split('.')[0].length > 7)
      ) {
        callback(new Error('输入数字过长')); // 小数点前7位或整数7位
      } else if (value.indexOf('.') != -1 && value.split('.')[1].length > 5) {
        callback(new Error('输入数字过长')); // 小数点后5位
      } else if (income && profit && Number(income) < Number(profit)) {
        callback(
          new Error(
            type === 'profit'
              ? '利润总额不能大于收入总额'
              : '收入总额不能小于利润总额'
          )
        );
      } else {
        callback();
      }
    },
    moneyRules(type, income, profit) {
      return {
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) =>
          this.validateMoney(rule, value, callback, type, income, profit),
      };
    },
    initAllData() {
      const that = this;
      const promises = [];
      const params = {
        statYear: currentYear,
      };
      this.tabsList.forEach((item, index) => {
        if (index > 0) {
          promises.push(
            new Promise((resolve, reject) => {
              Api.queryValveZoneDataInfo({ ...params, oprateType: item.value })
                .then((res) => {
                  if (res.code == '200') {
                    this[`tableData${index}`] = res.data;
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            })
          );
        } else {
          this.getData();
        }
      });
      Promise.all(promises)
        .then(() => {
          that.loading = false;
        })
        .catch((err) => {
          that.loading = false;
          console.log(err, 'err');
        });
    },
    getData(statYear) {
      this.isTableLoading = true;
      const params = {
        statYear: statYear || currentYear,
        oprateType: this.oprateType,
      };
      Api.queryValveZoneDataInfo(params).then((res) => {
        if (res.code === '200') {
          if (this.currentIndex == 0) {
            if (res.data && res.data.length) {
              if (
                res.data.findIndex((item) => item.statYear == currentYear) > -1
              ) {
                this.dynamicValidateForm.domains = res.data;
              } else {
                this.dynamicValidateForm.domains =
                  this.dynamicValidateForm.domains.concat(res.data);
              }
              this.handleDisabled();
            }
          } else {
            this[`tableData${this.currentIndex}`] = res.data || [];
          }
        }
        this.isTableLoading = false;
      });
    },
    handleTab(oprateType, index) {
      this.currentIndex = index;
      this.oprateType = oprateType;
    },
    // 新增行
    addDomain() {
      if (this.dynamicValidateForm.domains.length < 10) {
        this.disabledBtn = false;
        this.dynamicValidateForm.domains.push({
          statYear: this.lastTenYears[this.dynamicValidateForm.domains.length],
          income: '',
          profit: '',
        });
      }
      this.handleDisabled();
    },
    submitForm(formName) {
      // 保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(this.dynamicValidateForm.domains);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitData(result, y = null) {
      const resultData = result.map((item) => {
        return {
          ...item,
          oprateType: this.oprateType,
        };
      });
      Api.saveValveZoneDataInfo(resultData).then((res) => {
        if (res.code == '200') {
          this.$message.success('成功！');
          this.getData(y);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    submitTableData(res) {
      this.submitData(res.saveData, res.y);
    },
    handleDisabled() {
      if (this.dynamicValidateForm.domains.length == 10) {
        this.disabledBtn = true;
      }
    },
    getLastYear() {
      for (let i = currentYear - 9; i <= currentYear; i++) {
        this.lastTenYears.push(i);
      }
      this.lastTenYears.reverse();
    },
    getTabIndex() {
      return this.tabsList.findIndex((item) => item.value == this.currentTab);
    },
  },
};
</script>
<style lang="scss" scoped>
.enquiry-list {
  width: 100%;

  .tab-content {
    display: flex;
    align-items: center;

    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;

      &:last-child {
        border-right: 1px solid #d9d9d9;
      }

      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }

  .search-content {
    padding: 20px 20px 0;
    margin-bottom: 10px;
    width: 100%;
    border-top: 1px solid #d9d9d9;
    position: relative;
    top: -1px;
    //display: flex;
    background: #fff;

    .tips {
      width: 100%;
      min-height: 44px;
      line-height: 44px;
      background: #e8efff;
      box-sizing: border-box;
      padding: 0 20px;
      margin: 0px 0 10px;
      font-size: 16px;
      color: #333;

      .color {
        color: #ef4c56;
        font-weight: bold;
      }
    }

    .search-form {
      .el-form-item {
        flex: 0 0 316px;
        margin-bottom: 20px;
        margin-right: 20px;
      }

      .el-input {
        width: 186px;
      }
    }

    .search-btn {
      text-align: center;
      margin-left: 50px;

      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}
</style>
